
  const player = new Plyr('#heroVideo', {
    controls: ['play','progress','current-time','mute','volume','fullscreen']
  });

  const wrap = document.getElementById('videoWrap');
  const overlayBtn = document.getElementById('overlayPlay');
  const label = document.getElementById('overlayLabel');
  const text = document.getElementById('overlayText');

  overlayBtn.addEventListener('click', () => {
    player.togglePlay();
  });

  player.on('play', () => {
    wrap.classList.add('playing');
    label.firstChild.textContent = '⏸ ';
    text.textContent = 'Pause';
  });

  player.on('pause', () => {
    wrap.classList.remove('playing');
    label.firstChild.textContent = '▶ ';
    text.textContent = 'Play';
  });

  player.on('ended', () => {
    wrap.classList.remove('playing');
    label.firstChild.textContent = '▶ ';
    text.textContent = 'Play';
  });
